import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import ListingSearchSelect from '@components/Select/Select';
import { CloseIcon, ProfileReservation } from '@assets/icons';
import {
  DateType,
  formatMomentDate,
  getCurrentDate,
  getNMonthsLater,
  isInclusivelyAfterDay,
} from '@utils/dateUtil';
import { ResponsiveDatePickerWrapper } from '@components/DatePicker/DatePickerStyle';
import CustomIcon from '@components/utils/CustomIcon';
import { ResponsivePickerContent } from '@components/views/components/listing/drawer/ResponsiveSearchInputDrawer/ResponsiveSearchInputDrawerStyle';
import { useSearchBarContext } from '@contexts/hotel/SearchBar';
import ResponsiveDateRangePicker from '@components/DatePicker/DateRangePicker/ResponsiveDateRangePicker';
import { DrawerProps } from '@components/Drawer/next';
import { CalendarHolidaysViewModel } from '@api/v3';

import ResponsiveSearchDrawerItem from './ResponsiveSearchDrawerItem';
import {
  ResponsiveSearchDrawerButton,
  ResponsiveSearchSubmitButtonWrapper,
  StyledListingDateDrawer,
  ResponsiveListingSearchDateRangePicker,
} from './ResponsiveListingSearchStyle';

interface ResponsiveListingDateInterface {
  showDateModal: () => void;
  hideDateModal: () => void;
  handleUpdateDateValues?: () => void;
  isHoliday?: boolean;
  initialData?: CalendarHolidaysViewModel;
  setDefaultEndDate?: Dispatch<SetStateAction<string>>;
  setDefaultStarDate?: Dispatch<SetStateAction<string>>;
  isPackage?: boolean;
}
const ResponsiveListingSearchDate = ({
  showDateModal,
  hideDateModal,
  handleUpdateDateValues,
  isHoliday,
  visible,
  setDefaultEndDate,
  setDefaultStarDate,
  initialData,
  ...otherProps
}: React.PropsWithChildren<DrawerProps & ResponsiveListingDateInterface>) => {
  const { startDate, endDate, setDates } = useSearchBarContext();
  const [localStartDate, setLocalStartDate] = useState<DateType | null>(
    startDate
  );
  const [localEndDate, setLocalEndDate] = useState<DateType | null>(endDate);
  const handleUpdatedDate = (): void => {
    hideDateModal();
    setDates({ startDate: localStartDate, endDate: localEndDate });
    handleUpdateDateValues?.();
  };

  const handleDatesChange = ({
    startDate,
    endDate,
  }: {
    startDate: DateType | null;
    endDate: DateType | null;
  }) => {
    setLocalStartDate(startDate);
    setLocalEndDate(endDate);
  };

  const startDateString: string =
    formatMomentDate(visible ? localStartDate : startDate) ||
    'Giriş - Çıkış Tarihleri';

  const endDateString: string =
    formatMomentDate(visible ? localEndDate : endDate) ||
    (localStartDate || startDate ? 'Çıkış Tarihi Seçiniz' : '');
  useEffect(() => {
    setDefaultEndDate?.(endDateString);
    setDefaultStarDate?.(startDateString);
  }, [startDateString, endDateString]);
  const hasDate = startDate != null || endDate != null;
  return (
    <>
      <ResponsiveSearchDrawerItem
        title='Ne kadar kalacaksınız?'
        subTitle={`${startDateString} ${
          endDateString ? ' - ' + endDateString : ''
        }`}
        icon={ProfileReservation}
        arrowIcon={true}
        onClick={showDateModal}
        isFilled={hasDate || false}
      />
      {visible ? (
        <StyledListingDateDrawer
          closeIcon={
            <CustomIcon
              icon={CloseIcon}
              fontSize={24}
              paletteColor='darkGrey'
            />
          }
          visible={visible}
          {...otherProps}
          onClose={() => {
            setLocalStartDate(startDate);
            setLocalEndDate(endDate);
            hideDateModal();
          }}
        >
          <ResponsivePickerContent>
            <ResponsiveListingSearchDateRangePicker>
              <ListingSearchSelect
                className='responsive-select-box'
                label='Ne Kadar Kalacaksınız'
                text={`${startDateString}  ${
                  endDateString ? ' - ' + endDateString : ''
                }`}
                icon='calendar'
                selected={false}
                DatePicker={null}
              />
            </ResponsiveListingSearchDateRangePicker>

            <ResponsiveDatePickerWrapper>
              <ResponsiveDateRangePicker
                startDate={localStartDate}
                endDate={localEndDate}
                onDatesChange={handleDatesChange}
                isHoliday={isHoliday}
                initialData={initialData}
                isPadding={true}
                isOutsideRange={(day) =>
                  !isInclusivelyAfterDay(day, getCurrentDate()) ||
                  (localStartDate
                    ? !localEndDate
                      ? isInclusivelyAfterDay(
                          day,
                          getNMonthsLater(localStartDate, 1)
                        )
                      : false
                    : false)
                }
              />
            </ResponsiveDatePickerWrapper>
            <ResponsiveSearchSubmitButtonWrapper>
              <ResponsiveSearchDrawerButton
                variant='Primary'
                block
                onClick={handleUpdatedDate}
              >
                Uygula
              </ResponsiveSearchDrawerButton>
            </ResponsiveSearchSubmitButtonWrapper>
          </ResponsivePickerContent>
        </StyledListingDateDrawer>
      ) : null}
    </>
  );
};

export default ResponsiveListingSearchDate;
